import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import SpeechBalloon from '../../../domain/entities/SpeechBalloon';

export default function reducer(
  state: {[key: number]: SpeechBalloon} = {},
  action: AnyAction,
): {[key: number]: SpeechBalloon} {
  switch (action.type) {
    case Types.IndexSpeechBalloonsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: SpeechBalloon}, record: SpeechBalloon) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowSpeechBalloonSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
